import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/seguroincendios?include=contrato,imovel,tipocontrato,situcontrato,imoveltipo,inquilino,proprietarios,clausulaservico,metodocalculo,seguroiprevnumeroparcela,seguroistatu,seguroiparcelamento,seguroiformapagto`, options).then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };
  
  return axios
    .get(`${url}/seguroincendios/${id}?include=contrato,imovel,tipocontrato,situcontrato,imoveltipo,inquilino,proprietarios,clausulaservico,metodocalculo,seguroiprevnumeroparcela,seguroistatu,seguroiparcelamento,seguroiformapagto`, options)
    .then(response => {
      let seguroincendio = jsona.deserialize(response.data);
      delete seguroincendio.links;
      return seguroincendio;
    });
}

function add(seguroincendio) {
  const payload = jsona.serialize({
    stuff: seguroincendio,
    includeNames: ["categories"]
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  //.post(`${url}/seguroincendios?include=contrato,imovel,tipocontrato,situcontrato,imoveltipo,inquilino,proprietarios,clausulaservico,metodocalculo,seguroiprevnumeroparcela,seguroistatu,seguroiparcelamento,seguroiformapagto`, payload, options)
  return axios
    .post(`${url}/seguroincendios?include=contrato,imovel,tipocontrato,situcontrato,imoveltipo,inquilino,proprietarios,clausulaservico,metodocalculo,seguroiprevnumeroparcela,seguroistatu,seguroiparcelamento,seguroiformapagto`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(seguroincendio) {
  const payload = jsona.serialize({
    stuff: seguroincendio,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  return axios
    .patch(`${url}/seguroincendios/${seguroincendio.id}?include=contrato,imovel,tipocontrato,situcontrato,imoveltipo,inquilino,proprietarios,clausulaservico,metodocalculo,seguroiprevnumeroparcela,seguroistatu,seguroiparcelamento,seguroiformapagto`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function updatedata(seguroincendio) {
  const payload = jsona.serialize({
    stuff: seguroincendio,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .patch(`${url}/seguroincendios/${seguroincendio.id}?include=contrato,clausulaservico,metodocalculo`, payload, options)

    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.delete(`${url}/seguroincendios/${id}`, options);
}
function downloadPDF(tipo, arquivo) {
  return axios.get(`${url}/downloads/${tipo}/${arquivo}.pdf`, { responseType: 'blob' }).then((response) => {
    return response.data;
  });
}
function downloadRelatorioPDF(relatorio, id) {
  return axios.get(`${url}/reports/${relatorio}/${id}`, { responseType: 'blob' }).then((response) => {
    return response.data;
  });
}
/*
function upload(seguroincendio, image) {
  const bodyFormData = new FormData();
  bodyFormData.append("attachment", image);

  return axios
    .post(`${url}/uploads/seguroincendios/${seguroincendio.id}/image`, bodyFormData)
    .then(response => {
      return response.data.url;
    });
}
export default {
  list,
  get,
  add,
  update,
  destroy,
  upload
};
*/
export default {
  list,
  get,
  add,
  update,
  updatedata,
  destroy,
  downloadPDF,
  downloadRelatorioPDF
};